'use strict';

angular.module('uniromaLandingApp')
    .factory('Omonimie', ['$resource',function ($resource) {
    	  return $resource('api/omonimie/:username', {}, {
            'get': {
                method: 'GET'
             }
        });
    }]);
